import * as Yup from "yup";

const changePasswordSchema = Yup.object({
  currentPassword: Yup.string().required("Current password is mendatory"),
  newPassword: Yup.string()
    .required("New password is mendatory")
    .min(
      8,
      "Must Contain 8 Characters, One Uppercase, One Lowercase, One Number and one special case Character"
    )
    .matches(/^(?=.*[a-z])/, "Must contain at least one lowercase character")
    .matches(/^(?=.*[A-Z])/, "Must contain at least one uppercase character")
    .matches(/^(?=.*[0-9])/, "Must contain at least one number")
    .matches(/^(?=.*[!@#%&])/, "Must contain at least one special character"),

  verifyNewPassword: Yup.string()
    .oneOf([Yup.ref("newPassword")], "Passwords does not match")
    .required("Confirm password is mendatory"),
});
const forgotEmailSchema = Yup.object({
  EmailAddress: Yup.string()
    .min(3, "Email or username have at least 3 charaxter")
    .max(50)
    .required("Email or User id is required"),
});

const resetPasswordSchema = Yup.object({
  newPassword: Yup.string()
    .min(
      8,
      "Must Contain 8 Characters, One Uppercase, One Lowercase, One Number and one special case Character"
    )
    .matches(/^(?=.*[a-z])/, "Must contain at least one lowercase character")
    .matches(/^(?=.*[A-Z])/, "Must contain at least one uppercase character")
    .matches(/^(?=.*[0-9])/, "Must contain at least one number")
    .matches(/^(?=.*[!@#%&])/, "Must contain at least one special character")
    .required("New password is mendatory"),

  confirmPassword: Yup.string()
    .oneOf([Yup.ref("newPassword")], "Passwords does not match")
    .required("Confirm password is mendatory"),
});

export { changePasswordSchema, forgotEmailSchema, resetPasswordSchema };
